import React from 'react';

import './Income.css';

export const Income = ({ textContent, incomeAmt }) => {
  return (
    <div className="income-row-wrapper">
      <div className="income-text-title">{textContent}</div>
      <div>${incomeAmt}</div>
    </div>
  );
};
